import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupRetailSettings } from "../../../Shared/NewForms/NFLookupRetailSettings";
import { NFLookupPriceType } from "../../../Shared/NewForms/NFLookupPriceType";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

const RetailSettingsDetailMain = () => {
  const { watch } = useFormContext();

  const {t} = useTranslation()
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("Created Date")} fieldName={"createdDate"} />
        </Col>
        <Col sm={6}>
          <NFLookupRetailSettings fieldName={"retailSettingId"} title={t("Cash register (retail)")} />
        </Col>
        <Col sm={6}>
          <NFLookupPriceType title={t("Price Type")} fieldName={"priceTypeId"} />
        </Col>
        <Col sm={6}>
          <NFLookupWarehouse title={t("Warehouse")} fieldName={"warehouseId"} companyId={watch('companyId')} required/>
        </Col>
      </Row>
    </>
  );
};

export default RetailSettingsDetailMain;
